module.exports = __webpack_public_path__ + "static/img/30005 (2).c0c7c93.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30005 (2).jpg
// module id = Hgb4
// module chunks = 14